module.exports = "/images/vendor/desiigner-svg/svg/ui/calendar.svg?f6c7b23f03701f7b33b60933959a5da9";